<template>
  <!--<default-layout>-->
  <div>
    <v-data-table
      :headers="headers"
      :items="payments"
      :loading="loading"
      :fixed-header="true"
      class="elevation-2"
      :multi-sort="false"
      :must-sort="true"
      sort-by="date"
      show-expand
      :hide-default-footer="true"
      disable-pagination
    >
      <template v-slot:top>
        <v-row>
          <!-- SEARCH -->
          <v-col class="pl-7">
            <v-text-field
              v-model="searchText"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              @keyup.enter="search()"
            ></v-text-field>
          </v-col>

          <!-- DATE RANGE -->
          <v-col>
            <v-menu
              ref="menu"
              v-model="showDatePicker"
              :close-on-content-click="false"
              :return-value.sync="dates"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="Date range"
                  prepend-icon="mdi-calendar-range"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="dates" scrollable range no-title>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.menu.save(dates)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
          </v-col>

          <v-col>
            <!-- SEARCH BUTTON-->
            <v-btn
              class="primary mt-3"
              @click="
                searchClicked = true;
                search();
              "
              :disabled="loading"
              >Search
            </v-btn>

            <!-- DOWNLOAD BUTTON-->
            <v-btn
              class="mt-3 ml-2"
              color="primary"
              x-small
              fab
              @click="download"
              :disabled="loading"
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | date }}
      </template>
      <template v-slot:item.clicksTotal="{ item }">
        {{ item.clicksTotal | dollarsCents }}
      </template>
      <template v-slot:item.callsTotal="{ item }">
        {{ item.callsTotal | dollarsCents }}
      </template>
      <template v-slot:item.subscriptionsTotal="{ item }">
        {{ item.subscriptionsTotal | dollarsCents }}
      </template>
      <template v-slot:item.total="{ item }">
        {{ item.total | dollarsCents }}
      </template>
      <template v-slot:item.paid="{ item }">
        {{ getPaidText(item) }}
      </template>

      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length" class="pt-5 pb-5">
          <v-simple-table class="md-layout-item receipt-table">
            <thead class="table-head">
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Quantity</th>
                <th>Unit Price</th>
                <th>Amount</th>
              </tr>
            </thead>
            <template>
              <!-- SUBSCRIPTIONS -->
              <tr
                v-for="subscription in item.subscriptions"
                :key="subscription.id"
              >
                <td>{{ item.createdAt | formatDate }}</td>
                <td>Premium listing ({{ subscription.facilityId }})</td>
                <td class="text-center">1</td>
                <td class="text-right">
                  {{ subscription.total | dollarsCents }}
                </td>
                <td class="text-right">
                  {{ subscription.total | dollarsCents }}
                </td>
              </tr>

              <!-- CALL CAMPAIGNS -->
              <tr v-for="calls in item.calls" :key="calls.campaignId">
                <td v-if="calls.periodStart">
                  {{ calls.periodStart | formatDate }} -
                  {{ calls.periodEnd | formatDate }}
                </td>
                <td v-else>{{ item.dateRange }}</td>
                <td>Premium Calls for facility {{ calls.facilityId }}</td>
                <td class="text-center">{{ calls.totalCalls }}</td>
                <td class="text-right">
                  {{ calls.interactionCost | dollarsCents }}
                </td>
                <td class="text-right">
                  {{
                    (calls.interactionCost * calls.totalCalls) | dollarsCents
                  }}
                </td>
              </tr>

              <!-- CLICK CAMPAIGNS -->
              <tr v-for="clicks in item.clicks" :key="clicks.campaignId">
                <td v-if="clicks.periodStart">
                  {{ clicks.periodStart | formatDate }} -
                  {{ clicks.periodEnd | formatDate }}
                </td>
                <td v-else>{{ item.dateRange }}</td>
                <td>Premium Clicks for facility {{ clicks.facilityId }}</td>
                <td class="text-center">{{ clicks.totalClicks }}</td>
                <td class="text-right">
                  {{ clicks.interactionCost | dollarsCents }}
                </td>
                <td class="text-right">
                  {{
                    (clicks.interactionCost * clicks.totalClicks) | dollarsCents
                  }}
                </td>
              </tr>

              <!-- PREVIOUS PAYMENTS -->
              <template
                v-if="item.partialPayments && item.partialPayments.length"
              >
                <tr
                  v-for="partialPayment in item.partialPayments"
                  :key="'payment-' + partialPayment.id"
                >
                  <td>
                    {{ partialPayment.createdAt | formatDate("MMM do yyyy") }}
                  </td>
                  <td>Credit</td>
                  <td class="text-center">1</td>
                  <td class="text-right">
                    {{ partialPayment.data | formatPrevPayment }}
                  </td>
                  <td class="text-right">
                    {{ partialPayment.data | formatPrevPayment }}
                  </td>
                </tr>
              </template>

              <!-- FREE ACCOUNT -->
              <tr v-if="item.free">
                <td>{{ item.createdAt | formatDate }}</td>
                <td>Free upgrade</td>
                <td class="text-center">1</td>
                <td class="text-right">
                  {{ (item.total * -1) | dollarsCents }}
                </td>
                <td class="text-right">
                  {{ (item.total * -1) | dollarsCents }}
                </td>
              </tr>
              <!---->
              <!-- TOTALS LINE -->
              <tr>
                <td class="invisible-cell"></td>
                <td class="invisible-cell"></td>
                <td class="invisible-cell"></td>
                <td class="text-right"><strong>TOTAL</strong></td>
                <td v-if="item.free" class="text-right">
                  {{ 0 | dollarsCents }}
                </td>
                <td v-else class="text-right">
                  {{ item.total | dollarsCents }}
                </td>
              </tr>
            </template>
          </v-simple-table>
        </td>
      </template>

      <template v-slot:body.append>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="text-right"><strong>Totals:</strong></td>
          <td>{{ sumOfPayments.clickTotal | dollarsCents }}</td>
          <td>{{ sumOfPayments.callTotal | dollarsCents }}</td>
          <td>{{ sumOfPayments.subscriptionTotal | dollarsCents }}</td>
          <td>{{ sumOfPayments.total | dollarsCents }}</td>
          <td></td>
        </tr>
      </template>
    </v-data-table>
  </div>
  <!--</default-layout>-->
</template>

<script>
import { getBillingRevenueReport } from "../../api/report";

import {
  addDays,
  addMinutes,
  format,
  parseISO,
  subMonths,
  startOfMonth
} from "date-fns";
import XLSX from "xlsx";
import Decimal from "decimal.js-light";

export default {
  name: "BillingReport",
  title: "Billing",
  data() {
    return {
      payments: [],
      limit: 10,
      offset: 0,
      loading: true,
      serverItemsLength: 0,
      startDate: format(subMonths(new Date(), 3), "yyyy-MM-dd"),
      endDate: format(new Date(), "yyyy-MM-dd"),
      searchText: "",
      dates: [
        format(startOfMonth(new Date()), "yyyy-MM-dd"),
        format(new Date(), "yyyy-MM-dd")
      ],
      showDatePicker: false,
      paymentTerm: 0,
      rawResult: null,
      paymentTerms: [],
      headers: [
        { text: "Provider", value: "companyName", sortable: false },
        { text: "City", value: "billingCity", sortable: false },
        { text: "State", value: "billingState", sortable: false },
        { text: "Zip", value: "billingZip", sortable: false },
        { text: "Type", value: "paymentTerm", sortable: false },
        { text: "Date", value: "createdAt", sortable: false },
        { text: "Click Total", value: "clicksTotal", sortable: false },
        { text: "Call Total", value: "callsTotal", sortable: false },
        {
          text: "Monthly Upgrade Fee Total",
          value: "subscriptionsTotal",
          sortable: false
        },
        { text: "Total", value: "total", sortable: false },
        { text: "Paid", value: "paid", sortable: false }
      ]
    };
  },

  filters: {
    formatDate(date, dateFormat = "MM/dd/yyyy") {
      if (!date) return;
      date = parseISO(date);
      return format(addMinutes(date, date.getTimezoneOffset()), dateFormat);
    }
  },

  computed: {
    dateRangeText() {
      if (this.dates[0] && this.dates[1]) {
        return this.dates.join(" – ");
      }
      return "";
    },

    sumOfPayments() {
      let total = new Decimal(0);
      let clickTotal = new Decimal(0);
      let callTotal = new Decimal(0);
      let subscriptionTotal = new Decimal(0);
      for (const payment of this.payments) {
        if (payment.free) {
          continue;
        }

        total = total.add(payment.total);
        clickTotal = clickTotal.add(payment.clicksTotal);
        callTotal = callTotal.add(payment.callsTotal);

        subscriptionTotal = subscriptionTotal.add(payment.subscriptionsTotal);
      }
      return {
        total: total.toFixed(2),
        clickTotal: clickTotal.toFixed(2),
        callTotal: callTotal.toFixed(2),
        subscriptionTotal: subscriptionTotal.toFixed(2)
      };
    },

    sumOfClicks() {
      let total = new Decimal(0);
      for (const payment of this.payments) {
        if (payment.free) {
          continue;
        }

        total = total.add(payment.clickTotal);
      }
      return total.toFixed();
    }
  },

  async mounted() {
    await this.search();
  },

  methods: {
    async search() {
      this.loading = true;
      const result = await getBillingRevenueReport(
        this.searchText,
        parseISO(this.dates[0]),
        parseISO(this.dates[1])
      );
      this.payments = result.items;
      this.loading = false;
    },

    download() {
      try {
        const paymentImport = [];
        const invoiceImport = [];
        const failedPayments = [];

        for (const payment of this.payments) {
          if (!payment.success && payment.paymetTerm === "Receipt") {
            failedPayments.push({
              TxnDate: format(parseISO(payment.createdAt), "MM/dd/yyyy"),
              PaymentRefNumber: payment.id,
              Customer: payment.companyName,
              Email: "",
              PaymentMethod: payment.type,
              InvoiceApplyTo: "",
              LineAmount: payment.total
            });
            continue;
          }
          paymentImport.push({
            TxnDate: format(parseISO(payment.createdAt), "MM/dd/yyyy"),
            PaymentRefNumber: payment.id,
            SalesTerm: this.getSalesTerm(payment),
            Customer: payment.company,
            Email: "",
            "Stripe Payment ID": payment.stripePaymentId,
            PaymentMethod: payment.type,
            InvoiceApplyTo: "",
            LineAmount: payment.total
          });

          // SUBSCRIPTIONS
          if (payment.subscriptions && payment.subscriptions.length) {
            for (const subscription of payment.subscriptions) {
              invoiceImport.push(
                this.createInvoice(
                  payment,
                  "Monthly Upgrade Fee",
                  `Monthly Upgrade Fee for facility ${subscription.facilityId}`,
                  1,
                  parseFloat(
                    this.getSubscriptionLineUnitPrice(subscription, payment)
                  ),
                  parseFloat(
                    this.getSubscriptionLineUnitPrice(subscription, payment)
                  )
                )
              );
            }
          }

          // CALL CAMPAIGNS
          if (payment.calls && payment.calls.length) {
            for (const callData of payment.calls) {
              if (callData.totalCalls) {
                invoiceImport.push(
                  this.createInvoice(
                    payment,
                    "Premium Calls",
                    `Premium Calls for facility ${callData.facilityId}`,
                    callData.totalCalls,
                    this.getCampaignLineUnitPrice(
                      callData.interactionCost,
                      payment
                    ),
                    this.campaignLineTotal(
                      this.getCampaignLineUnitPrice(
                        callData.interactionCost,
                        payment
                      ),
                      callData.totalCalls
                    )
                  )
                );
              }
            }
          }

          // CLICK CAMPAIGNS
          if (payment.clicks && payment.clicks.length) {
            for (const clickData of payment.clicks) {
              if (clickData.totalClicks) {
                invoiceImport.push(
                  this.createInvoice(
                    payment,
                    "Premium Clicks",
                    `Premium Clicks for facility ${clickData.facilityId}`,
                    clickData.totalClicks,
                    this.getCampaignLineUnitPrice(
                      clickData.interactionCost,
                      payment
                    ),
                    this.campaignLineTotal(
                      this.getCampaignLineUnitPrice(
                        clickData.interactionCost,
                        payment
                      ),
                      clickData.totalClicks
                    )
                  )
                );
              }
            }
          }
        }

        const paymentImportWS = XLSX.utils.json_to_sheet(paymentImport);
        const invoiceImportWS = XLSX.utils.json_to_sheet(invoiceImport);
        const failedPaymentWS = XLSX.utils.json_to_sheet(failedPayments);
        const wb = XLSX.utils.book_new(); // make Workbook of Excel
        // add Worksheet to Workbook
        // Workbook contains one or more worksheets
        XLSX.utils.book_append_sheet(wb, paymentImportWS, "Payment Import"); // sheetAName is name of Worksheet
        XLSX.utils.book_append_sheet(wb, invoiceImportWS, "Invoice Import");
        XLSX.utils.book_append_sheet(wb, failedPaymentWS, "Failed Payments");

        XLSX.writeFile(wb, "book.xlsx");
      } catch (e) {
        console.error(e);
        alert("There was an error exporting the data: " + e);
      }
    },

    createInvoice(
      payment,
      lineItem,
      lineItemDesc,
      lineQty,
      lineUnitPrice,
      lineTotal
    ) {
      return {
        "Invoice #": payment.id,
        Customer: payment.companyName,
        TxnDate: format(parseISO(payment.createdAt), "MM/dd/yyyy"),
        DueDate: this.getDueDate(payment),
        SalesTerm: this.getSalesTerm(payment),
        BillAddrLine1: payment.billingAddressLine1,
        BillAddrLine2: payment.billingAddressLine2,
        BillAddrLine3: null,
        BillAddrLine4: null,
        BillAddrCity: payment.billingCity,
        BillAddrState: payment.billingState,
        BillAddrPostalCode: payment.billingZip,
        BillAddrCountry: payment.billingCountry,
        BillEmail: "",
        LineItem: lineItem,
        LineDesc: lineItemDesc,
        LineQty: lineQty,
        LineUnitPrice: lineUnitPrice,
        LineTotal: lineTotal
      };
    },

    getSalesTerm(payment) {
      if (payment.free) {
        return "Free";
      } else if (payment.paymentTerm) {
        return payment.paymentTerm;
      }
      return null;
    },

    getPaidText(payment) {
      if (payment.free) {
        return "Free";
      } else if (payment.paymentTerm == "Invoice") {
        return "N/A";
      }

      return payment.success ? "Yes" : "No - Failed";
    },

    getDueDate(payment) {
      if (payment.free) {
        return "N/A";
      } else if (payment.paymentTerm == "Invoice") {
        return format(addDays(parseISO(payment.createdAt), 5), "MM/dd/yyyy");
      }
      return "N/A";
    },

    getSubscriptionLineUnitPrice(subscription, payment) {
      if (payment.free) {
        return 0;
      }
      return parseFloat(new Decimal(subscription.total).toFixed(2));
    },

    getCampaignLineUnitPrice(interactionCost, payment) {
      if (payment.free) {
        return 0;
      }
      return parseFloat(new Decimal(interactionCost).toFixed(2));
    },

    campaignLineTotal(interactionCost, numInteractions) {
      const decimalInteractionCost = new Decimal(interactionCost);
      if (!numInteractions) {
        numInteractions = 0;
      }

      const total = decimalInteractionCost.mul(numInteractions);
      return parseFloat(total.toFixed(2));
    }
  }
};
</script>

<style scoped></style>
